import React from 'react';
import { 
  Dialog, DialogTitle, DialogContent, 
  DialogContentText, DialogActions, Button 
} from '@material-ui/core';

export const ConfirmDeleteDialog = ({ open, handleClose, handleConfirm, agentName }) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle style={{ backgroundColor: '#4caf50', color: '#fff' }}>
        Confirm Delete
      </DialogTitle>
      <DialogContent style={{ marginTop: '20px' }}>
        <DialogContentText>
          Are you sure you want to delete <strong>{agentName}</strong>? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="default">
          Cancel
        </Button>
        <Button onClick={handleConfirm} style={{ color: '#d32f2f' }} autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};